import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../lib/firebase';
import { useAuth } from '../../hooks/useAuth';
import { useUiStore } from '../../store/uiStore';
import { Spinner } from '../../components/Spinner';

export function VerifyEmail() {
  const { resendVerification, logout } = useAuth();
  const navigate = useNavigate();
  const pushToast = useUiStore((s) => s.pushToast);

  const [resending, setResending] = useState(false);
  const [reloading, setReloading] = useState(false);

  async function handleResend() {
    setResending(true);
    try {
      await resendVerification();
      pushToast('success', 'Verification email sent.');
    } catch (err) {
      pushToast(
        'error',
        err instanceof Error ? err.message : 'Could not send email',
      );
    } finally {
      setResending(false);
    }
  }

  async function handleReload() {
    setReloading(true);
    try {
      await auth.currentUser?.reload();
      window.location.assign('/');
    } catch (err) {
      pushToast(
        'error',
        err instanceof Error ? err.message : 'Could not reload',
      );
      setReloading(false);
    }
  }

  async function handleLogout() {
    try {
      await logout();
      navigate('/login');
    } catch (err) {
      pushToast('error', err instanceof Error ? err.message : 'Logout failed');
    }
  }

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-slate-100">Verify your email</h2>
      <p className="text-sm text-slate-300">
        You need to verify your email address before you can play. Check your
        inbox for the verification link, then return here and reload.
      </p>

      <button
        type="button"
        className="btn-gold w-full"
        onClick={handleReload}
        disabled={reloading}
      >
        {reloading ? <Spinner /> : "I've verified — reload"}
      </button>

      <button
        type="button"
        className="btn-ghost w-full"
        onClick={handleResend}
        disabled={resending}
      >
        {resending ? <Spinner /> : 'Resend verification'}
      </button>

      <button type="button" className="btn-ghost w-full" onClick={handleLogout}>
        Log out
      </button>
    </div>
  );
}
